import React from "react";
import { Link } from "gatsby";
import { css } from "glamor";

export default ({ ...props }) => (
  <Link to={props.pathFr} {...cssSubLink}>
    <span role="img" aria-label="French flag - drapeau français">
      🇫🇷
    </span>{" "}
    French version
  </Link>
);

const cssSubLink = css({
  display: `block`,
  fontSize: `.7em`,
  fontWeight: `400`,
  color: `white`,
  textDecoration: `none`,
  letterSpacing: `0.02em`,
  paddingTop: `.2em`,
});
